import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAIqyBKcRNJ848dB7g37XlWS1FFxoIEWA4",
  authDomain: "bleat-api.firebaseapp.com",
  projectId: "bleat-api",
  databaseURL: "https://bleat-api-default-rtdb.firebaseio.com",
  storageBucket: "bleat-api.appspot.com",
  messagingSenderId: "339479587043",
  appId: "1:339479587043:web:390f9e1f4f1eb419437dd6",
  measurementId: "G-NL31YKEW48"
};

const app = initializeApp(firebaseConfig);


export default app;
